import { Injectable } from '@angular/core';
import {
    MatLegacySnackBar as MatSnackBar,
    MatLegacySnackBarRef as MatSnackBarRef
} from '@angular/material/legacy-snack-bar';
import { SbToastComponent } from './sb-toast.component';
import { Observable } from 'rxjs';
export interface Toast {
    intent?: 'info' | 'success' | 'warning' | 'critical';
    message: string;
    title?: string;
    actions?: {
        primary?: string;
        secondary?: string;
    };
    duration?: number;
}

export interface ToastAction {
    event: MouseEvent;
    name: ToastActionType;
}

export type ToastActionType = 'primary' | 'secondary';

export interface ToastRef extends MatSnackBarRef<any> {
    $action: Observable<ToastAction>;
}
@Injectable({
    providedIn: 'root'
})
export class ToastService {
    constructor(private toast: MatSnackBar) {}

    private _defaultTitle(intent: Toast['intent']): string {
        switch (intent) {
            case 'success':
                return '🥳 Well done!';
            case 'critical':
                return '⚠️ An error has occurred!';
            default:
                return '';
        }
    }

    /** Show - Show toast
     *  @param toast - Toast object to show
     *  @return toastRef - Reference to toast instance
     */
    public show({
        intent = 'info',
        message,
        title = this._defaultTitle(intent),
        actions,
        duration
    }: Toast) {
        let toast = this.toast.openFromComponent(SbToastComponent, {
            panelClass: ['sb-toast', intent],
            horizontalPosition: 'start',
            verticalPosition: 'bottom',
            duration: duration || 10000,
            data: {
                title,
                message,
                actions
            }
        }) as Partial<ToastRef>;
        toast.$action = toast.instance.$action;
        return toast as ToastRef;
    }
}
